import { Directive, ElementRef, Input, OnChanges } from '@angular/core';

@Directive({
  selector: '[loading]'
})
export class LoadingDirective implements OnChanges {
  @Input() loading: any;
  $element: any;
  constructor(private element: ElementRef) {
    this.$element = $(this.element.nativeElement);
    this.$element.addClass('ws-loading');
  }
  ngOnChanges(change) {
    if (!!change.loading.currentValue) {
      this.element.nativeElement.disabled = true;
      this.$element.addClass('ws-loading-progress');
    } else {
      this.$element.removeClass('ws-loading-progress');
      this.element.nativeElement.disabled = false;
    }
  }
}
